module.exports = __webpack_public_path__ + "static/media/DIWALIMAGAZINE.376e0d73.jpg";